<ng-template [ngIf]="isMesAtualInitChecked">
    <ng-template [ngIf]="!grupoClassificacao">
        <div class="alert alert-info alert-no-grupo-classificacao">
            <h5 class="alert-heading">
               <i class="fas fa-info" aria-hidden="true"></i> Nenhum grupo de segementos selecionado
            </h5>
            <p class="m-0">Selecione um grupo de segmentos no filtro para poder lançar a análise de mercado</p>
        </div>
    </ng-template>
    
    <ng-template [ngIf]="grupoClassificacao">
        <!-- List -->
        <sgt-cliente-analise-mercado-perspectiva-projetada-list
            *ngIf="isVisualizacaoModoList"
            #list
            [filter]="filter"
            [isMesAtual]="isMesAtual"
            [controleQuantidade]="grupoClassificacao?.controleQuantidade"
            [controlePeso]="grupoClassificacao?.controlePeso"
            [controleValor]="grupoClassificacao?.controleValor"
            [grupoClassificacao]="grupoClassificacao">
        </sgt-cliente-analise-mercado-perspectiva-projetada-list>
    </ng-template>

</ng-template>
